/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePlanTaskCommentRequest
 */
export interface CreatePlanTaskCommentRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePlanTaskCommentRequest
     */
    body: string;
}

/**
 * Check if a given object implements the CreatePlanTaskCommentRequest interface.
 */
export function instanceOfCreatePlanTaskCommentRequest(value: object): value is CreatePlanTaskCommentRequest {
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function CreatePlanTaskCommentRequestFromJSON(json: any): CreatePlanTaskCommentRequest {
    return CreatePlanTaskCommentRequestFromJSONTyped(json, false);
}

export function CreatePlanTaskCommentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlanTaskCommentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'body': json['body'],
    };
}

export function CreatePlanTaskCommentRequestToJSON(json: any): CreatePlanTaskCommentRequest {
    return CreatePlanTaskCommentRequestToJSONTyped(json, false);
}

export function CreatePlanTaskCommentRequestToJSONTyped(value?: CreatePlanTaskCommentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'body': value['body'],
    };
}

